export default __webpack_public_path__ + "media/images/elements/10-e179c526abe32db00398a94a68c31360.png";